import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { User } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { WhoamiPage } from "./pages/WhoamiPage";

export const whoamiModule: FeatureModule = {
  key: "whoami",
  nav: {
    label: "Whoami",
    icon: User,
    to: "/whoami",
    requires: "whoami.read",
    order: 90,
    group: "System",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/whoami",
      component: guarded("whoami.read", WhoamiPage),
    }),
  ] as unknown as AnyRoute[],
};
